import React from 'react';
import firebase from 'firebase/compat/app';

const firestore = firebase.firestore();
var _ = require('lodash');
var moment = require('moment');

/* DATABASE ----------------------------------------------------------------------------*/

export async function nextId(handle, batch, table, field, startingId) {

	batch.update(firestore.collection(handle).doc(table), { [field]: firebase.firestore.FieldValue.increment(1) });

	var doc = await firestore.collection(handle).doc(table).get();
	if (!doc.exists || !doc.data()[field]) {
		await firestore.collection(handle).doc(table).set({ [field]: startingId }, { merge: true });
	}
	return (doc.exists && doc.data()[field]) ? doc.data()[field]?.toString() : startingId.toString();
}

/* FORMS & VALIDATION ----------------------------------------------------------------------------*/

export function process_error(error, message) {

	if (error.toString().includes('code 401')) {
		window.toastr.warning(error, 'UNAUTHORIZED!');
	} else {
		window.toastr.error(error, message);
	}
}

/* MODIFICATION ----------------------------------------------------------------------------------*/

// this function utilizes each of the following three functions to perform a list link (e.g. Asset Search)
export function listLink(history, path, position, value, optional, lastpos) {
	let location = modifyPath(path, position, value, lastpos);
	let segments = value.split("/").length;
	location = modifyPathIfEmpty(location, position + segments, optional);
	pushOrReplace(history, path, position, location);
}

export function modifyPath(path, position, value, lastpos) {  // modify path position with value. Ignore after lastpos
	let pathArray = path.split('/');
	if (position <= pathArray.length - 1) {
		let valueArray = value.split('/');
		for (let x = 0; x < valueArray.length; x++) {
			pathArray[position + x] = valueArray[x];
		}
	} else {
		pathArray.push(value);
	}
	if (lastpos) pathArray = pathArray.slice(0, lastpos + 1);
	return pathArray.join('/');
}
export function modifyPathIfEmpty(path, position, value, lastpos) { // add value at path position, if that position is empty
	// This is designed to keep certain tabs open
	let pathArray = path.split('/');
	if (position > pathArray.length - 1) {
		let valueArray = value.split('/');
		for (let x = 0; x < valueArray.length; x++) {
			pathArray[position + x] = valueArray[x];
		}
	}
	if (lastpos) pathArray = pathArray.slice(0, lastpos + 1);
	return pathArray.join('/');
}
export function pushOrReplace(history, path, breakpoint, location) {
	let currentSegments = path.split("/").length;
	if (currentSegments === breakpoint) {
		history.push({ pathname: location });
	} else {
		history.replace({ pathname: location });
	}
}

/* FORMAT ----------------------------------------------------------------------------------------*/

export function UCFirst(string) {

	return string.charAt(0).toUpperCase() + string.slice(1);

}
export function humanize(str) {
	if (str) {
		var i, frags = str.split('_');
		for (i = 0; i < frags.length; i++) {
			frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
		}

		return frags.join(' ');
	}
}
export function format_address(address1, address2, city, state, zip, phone, email, commas, newline) {

	var address = [];

	if (address1) address.push(address1 + ((commas) ? ', ' : ''));
	if (address1 && newline) address.push(<br key={'address1' + address1} />);

	if (address2) address.push(address2 + ((commas) ? ', ' : ''));
	if (address2 && newline) address.push(<br key={'address2' + address2} />);

	if (city) address.push(city + ((state || zip) ? ', ' : ''));
	if (state) address.push(state + ((zip) ? ' ' : ''));
	if (zip) address.push(zip);
	if (city || state || zip) address.push(<br key={'citystatezip' + city + state + zip} />);
	if (city || state || zip) address.push(<br key={'citystatezip2' + city + state + zip} />);

	if (phone) {
		address.push('Phone: ');
		address.push(<a key={'phonelink' + phone} href="tel:'+phone+'">{phone}</a>);
		address.push((commas) ? ', ' : '');
	}
	if (phone && newline) address.push(<br key={'phone' + phone} />);

	if (email) {
		address.push('Email: ');
		address.push(<a key={'emaillink' + email} href={'mailto:' + email}>{email}</a>);
		address.push((commas) ? ', ' : '');
	}
	if (email && newline) address.push(<br key={'email' + email} />);

	return address;
}
export function formatNumber(amount, decimalCount = 2) {

	decimalCount = Math.abs(decimalCount);
	decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

	const negativeSign = amount < 0 ? "-" : "";

	let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
	let j = (i.length > 3) ? i.length % 3 : 0;

	return negativeSign + (j ? i.substr(0, j) + ',' : '') + (i.substr(j).replace(/(\d{3})(?=\d)/g, "$1,")) + (decimalCount ? '.' + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
};

export function dateOrDash(date, format = 'MM/DD/YYYY') {
	if (!date) return '-';
	return moment(date?.toDate()).format(format);
}

export function removeWhitespace(string) {
	return string.replace(/\s+/g, ' ').trim();
}

export function sortByPosition(arr) {
	return arr.sort(function (a, b) {
		var x = a.position; var y = b.position;
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	});
}

export function toProperCase(string) {
	if (!string) return;
	return string.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

export function sanitize(record, fields) {
	let santized = {};
	for (const [key, value] of Object.entries(record)) {
		if (fields.includes(key) && value !== undefined) santized[key] = (typeof value === 'string') ? value.trim() : value;
	} 
	return santized;
}

var react_1 = require("react");
export function useStateCallback(initialState) {
	var _a = (0, react_1.useState)(initialState), state = _a[0], _setState = _a[1];
	var callbackRef = (0, react_1.useRef)();
	var isFirstCallbackCall = (0, react_1.useRef)(true);
	var setState = (0, react_1.useCallback)(function (setStateAction, callback) {
		callbackRef.current = callback;
		_setState(setStateAction);
	}, []);
	(0, react_1.useEffect)(function () {
		var _a;
		if (isFirstCallbackCall.current) {
			isFirstCallbackCall.current = false;
			return;
		}
		(_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, state);
	}, [state]);
	return [state, setState];
}
export function sortByField(arr, field, reverse) {
	if (!reverse) return arr?.sort((a, b) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0));
	else return arr?.sort((a, b) => (a[field] < b[field]) ? 1 : ((b[field] < a[field]) ? -1 : 0));
}
export function createHandle(string) {
	return string.replace(/\s+/g, ' ').trim().replace(/ /g, "_").replace(/\W/g, '').toLowerCase();
}

export function getOrdinal(n) {
	let ord = 'th';

	if (n % 10 == 1 && n % 100 != 11) {
		ord = 'st';
	}
	else if (n % 10 == 2 && n % 100 != 12) {
		ord = 'nd';
	}
	else if (n % 10 == 3 && n % 100 != 13) {
		ord = 'rd';
	}

	return ord;
}

